import { PropsWithChildren, createContext, useContext } from 'react';

import { AppNavbarActionsDrawerProps } from '../AppNavbarActionsDrawer';

type TAppNavbarActionsDrawerContextBase = {
  onSubmit: () => void;
  onCancel: () => void;
};

type IAppNavbarActionsDrawerContext = TAppNavbarActionsDrawerContextBase &
  Pick<AppNavbarActionsDrawerProps, 'isOpen'>;

const AppNavbarActionsDrawerContext = createContext<IAppNavbarActionsDrawerContext>(undefined!);

const AppNavbarActionsDrawerProvider = ({
  children,
  onSubmit: oldOnSubmit,
  onCancel: oldOnCancel,
  ...otherProps
}: PropsWithChildren<AppNavbarActionsDrawerProps>) => {
  const onSubmit = () => {
    oldOnSubmit();
  };

  const onCancel = () => {
    oldOnCancel();
  };

  const state: IAppNavbarActionsDrawerContext = {
    onSubmit,
    onCancel,
    ...otherProps,
  };

  return (
    <AppNavbarActionsDrawerContext.Provider value={state}>
      {children}
    </AppNavbarActionsDrawerContext.Provider>
  );
};

const useAppNavbarActionsDrawerContext = () => useContext(AppNavbarActionsDrawerContext);

export { AppNavbarActionsDrawerProvider, useAppNavbarActionsDrawerContext };
